import { Component, NgZone, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { UpgradeGuideComponent } from './upgrade-guide/upgrade-guide.component';
import { HttpService } from 'src/app/_provider/http.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { environment } from 'src/environments/environment';
import * as semver from "semver"

export enum FeaturePlatform{
  APPLE = "fa-apple",
  ANDROID = "fa-android",
  BROWSER = "fa-browser"
}

export interface Version{
  description: string,
  date?: string,
  features: NewFeature[]
}

export interface NewFeature{
  type: "bug" | "feature" 
  description: string
  text: string,
  platforms?: FeaturePlatform[],
  requiredServerUpdate?: boolean
  images?: string[]
}

@Component({
  selector: 'app-new-features',
  templateUrl: './new-features.page.html',
  styleUrls: ['./new-features.page.scss'],
})
export class NewFeaturesPage implements OnInit {

  public isLoading: boolean = true

  constructor(
    private modalCtrl: ModalController,
    private feedback: FeedbackService,
    private http: HttpService,
    private ngZone: NgZone
  ) { 
    this.http.getChangelog().then((result: HttpFunctionResult<Version[]>)=>{
      this.ngZone.run(()=>{
        this.isLoading = false
        if(!result.success)
          return this.feedback.showError("Fehler beim Laden des Changelogs.")
        this.versions = result.data.filter(v=>!semver.lt(environment.version, v.description.replace("V", "")))
      })
    })
  }
  
  ngOnInit() {
  }
  
  public async closeModal(){
    await this.modalCtrl.dismiss()
  }
  
  public async openUpgradeGuide(){
    await this.feedback.openModal(UpgradeGuideComponent)
  }
  
  public versions: Version[] = []

}
